<template>
    <div>
        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
<title>block_duplicate</title>
<path fill="#679940" d="M14.88 14.56h-12.267v-12.267h12.267v12.267zM3.733 13.44h10.027v-10.027h-10.027v10.027z"></path>
<path fill="#679940" d="M29.013 14.56h-12.267v-12.267h12.267v12.267zM17.867 13.44h10.027v-10.027h-10.027v10.027z"></path>
<path fill="#679940" d="M14.72 28.267h-12.267v-12.267h12.267v12.267zM3.573 27.2h10.027v-10.080h-10.027v10.080z"></path>
<path fill="#679940" d="M28.907 28.267h-12.267v-12.267h12.267v12.267zM17.76 27.2h10.027v-10.080h-10.027v10.080z"></path>
<path fill="#679940" d="M20.907 20h-12.267v-12.267h12.267v12.267zM9.76 18.88h10.027v-10.027h-10.027v10.027z"></path>
<path fill="#679940" d="M25.867 26.453h-12.267v-12.267h12.267v12.267zM14.72 25.333h10.027v-10.027h-10.027v10.027z"></path>
</svg>
    </div>
</template>

<script>
export default {
    name: "OperationsIcon"
}
</script>


// WEBPACK FOOTER //
// src/icons/OperationsIcon.vue